/* eslint-disable import/prefer-default-export, react/display-name */
import React from 'react';
// Custom
import InternalLink from './InternalLink';

export const getInternalLink = (path) => React.forwardRef((props, ref) => <InternalLink ref={ref} path={path} {...props} />);

export const getMuiColor = (primary, secondary, inherit, defaultColor = 'default') => {
  if (inherit) {
    return 'inherit';
  }
  if (secondary) {
    return 'secondary';
  }
  if (primary) {
    return 'primary';
  }
  return defaultColor;
};



// WEBPACK FOOTER //
// ./components/core/internal/Tools.js